/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FetchPropertyValuesRequest
 */
export interface FetchPropertyValuesRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchPropertyValuesRequest
     */
    propertyName: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FetchPropertyValuesRequest
     */
    formData: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FetchPropertyValuesRequest
     */
    entityName?: string;
}

/**
 * Check if a given object implements the FetchPropertyValuesRequest interface.
 */
export function instanceOfFetchPropertyValuesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "propertyName" in value;
    isInstance = isInstance && "formData" in value;

    return isInstance;
}

export function FetchPropertyValuesRequestFromJSON(json: any): FetchPropertyValuesRequest {
    return FetchPropertyValuesRequestFromJSONTyped(json, false);
}

export function FetchPropertyValuesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchPropertyValuesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyName': json['propertyName'],
        'formData': json['formData'],
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
    };
}

export function FetchPropertyValuesRequestToJSON(value?: FetchPropertyValuesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'propertyName': value.propertyName,
        'formData': value.formData,
        'entityName': value.entityName,
    };
}

